import React from 'react'
import classNames from 'classnames'
import classes from './OptionToggle.module.css'

export const OptionToggle = ({
    options: { left, right },
    className,
    activeOption,
    onChangeOption,
    ...props
}) => {
    const activeDirection = activeOption === left.id ? 'left' : 'right'
    const switchOption = () => {
        onChangeOption(activeDirection === 'left' ? right.id : left.id)
    }
    return (
        <div className={classNames(classes.optionToggle, className)} {...props}>
            <span
                role="checkbox"
                arial-abel={left.label}
                aria-checked={activeDirection === 'left'}
                className={classNames(
                    classes.option,
                    activeDirection === 'left' && classes.activeOption
                )}
                onClick={() => onChangeOption(left.id)}
            >
                {left.label}
            </span>
            <div
                role="button"
                className={classNames(
                    classes.switch,
                    activeDirection === 'left'
                        ? classes.activeLeft
                        : classes.activeRight
                )}
                onClick={switchOption}
            />
            <span
                role="checkbox"
                arial-abel={right.label}
                aria-checked={activeDirection === 'right'}
                className={classNames(
                    classes.option,
                    activeDirection === 'right' && classes.activeOption
                )}
                onClick={() => onChangeOption(right.id)}
            >
                {right.label}
            </span>
        </div>
    )
}
